import React, { ReactElement, useEffect, useState } from 'react';
import { BarLoader } from 'react-spinners';
import { useGetGiftTypesMutation } from '../../../../services/api/apiProvider';
import {
  ResponseGift,
  ResponseGiftCategory,
} from '../../../../services/api/models/response/responseGift';
import { GiftItem } from './GiftItem';
import './GiftTab.scss';
import { API_BASE_URL } from '../../../../loadEnv';

interface GiftTabProps {
  giftCategory: ResponseGiftCategory;
}

export const GiftTab = (props: GiftTabProps): ReactElement => {
  const [loading, setLoading] = useState(true);
  const [giftsData, setGiftsData] = useState<ResponseGift[]>([]);
  const [getGiftTypes] = useGetGiftTypesMutation();

  useEffect(() => {
    setLoading(true);
    getGiftTypes({ giftCategoryId: props.giftCategory.id })
      .unwrap()
      .then((data) => {
        setGiftsData(data);
        setLoading(false);
      });
  }, []);

  return (
    <div className="gift-tab">
      {loading && (
        <div className="gift-tab__loader">
          <BarLoader color={'#0275d8'} width="100%"></BarLoader>
        </div>
      )}

      <div className="gift-tab__body">
        {giftsData && (
          <div className="list-gift">
            {giftsData.map((gift) => (
              <GiftItem key={gift.id} gift={gift} />
            ))}
          </div>
        )}
        {props.giftCategory.displayName === 'エブリルーレット' && (
          <a
            style={{ color: '#999999' }}
            href="https://everylive.jp/faq/faq051/"
            target="_blank"
            rel="noreferrer"
          >
            エブリルーレットとは
          </a>
        )}
        {props.giftCategory.name === '定番ランダム' && (
          <a
            style={{ color: '#999999' }}
            href={
              API_BASE_URL === 'https://api.dev.everylive.jp'
                ? 'https://site.dev.everylive.jp/faq/faq052/'
                : ' https://everylive.jp/faq/faq052/'
            }
            target="_blank"
            rel="noreferrer"
          >
            {props.giftCategory.displayName}とは
          </a>
        )}
      </div>
    </div>
  );
};
